export default class SaveProposalHandlerError extends Error {
}
